import { SmartSubscribe } from '@dinosband/bv-main-client'
import { queryLastUpdatedMessages, subscribeMessageUpdated } from '@dinosband/bv-messenger-client'
import { Message } from '@dinosband/bv-messenger-schema'
import { BvDataCenterContext } from '..'
import { BvSubscriber } from './manager/subscriber'

export class MessageUpdateSubscriber extends BvSubscriber<Message> {

  context: BvDataCenterContext
  chatRoomIds: number[]

  constructor (context: BvDataCenterContext, chatRoomIds: number[], callback: (value: Message | Message[]) => void) {
    super(callback)
    this.context = context
    this.chatRoomIds = chatRoomIds
  }

  protected async query () {
    return await queryLastUpdatedMessages(await this.context.messengerClient.getClient(), this.chatRoomIds) as Message[]
  }

  protected async subscribe () {
    const subscription = subscribeMessageUpdated(await this.context.messengerClient.getClient(), this.chatRoomIds).subscribe({
      next: async (value) => {
        if (value.data?.updatedMessage) {
          this.callback(value.data.updatedMessage)
        }
      },
      error: console.error,
    })
    return subscription as unknown as SmartSubscribe
  }

}
